import { render, staticRenderFns } from "./RegPayment.vue?vue&type=template&id=de604472&scoped=true&"
import script from "./RegPayment.vue?vue&type=script&lang=js&"
export * from "./RegPayment.vue?vue&type=script&lang=js&"
import style0 from "./RegPayment.vue?vue&type=style&index=0&id=de604472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de604472",
  null
  
)

export default component.exports